module.exports = __webpack_public_path__ + "static/media/group-133.8700f50a.svg";